const t = (key, fallback = '') => (window.BL_I18N && BL_I18N[key]) || fallback || key;
const CURRENT_LOCALE = (window.BL_I18N && BL_I18N.locale) || document.documentElement.lang || 'en-US';

class ConfirmationLongApi {
    constructor() {
        this.$loader  = $('#booking-loader');
        this.$content = $('#confirmation-content');
        this.$error   = $('#booking-error');

        this.$bdHost    = $('[data-role="booking-details"]');
        this.$priceHost = $('[data-role="price-breakdown"]');

        this.currency = window.BL_CURRENCY || 'CHF';
        this.locale   = window.BL_LOCALE   || 'de-CH';
        this.bookingId = this.getParam('bookingId');
        this.code = (window.BL_AJAX && BL_AJAX.confirmation_code) || '';
        this.ref = this.getParam('ref');

        this.boot();
    }

    /* ------------ utils ------------ */
    getParam(k){ try{ return new URLSearchParams(location.search).get(k) || ''; }catch{ return '';} }
    showLoader(){ this.$loader.removeClass('hidden'); this.$content.addClass('hidden'); this.$error.addClass('hidden'); }
    showContent(){ this.$loader.addClass('hidden'); this.$error.addClass('hidden'); this.$content.removeClass('hidden'); }
    showError(msg){ this.$loader.addClass('hidden'); this.$error.text(msg||'Booking not found.').removeClass('hidden'); this.$content.addClass('hidden'); }
    esc(s){ return String(s||'').replace(/[&<>"']/g,m=>({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[m])); }
    money(n){ const v=Number(n)||0;
        try{ return new Intl.NumberFormat(this.locale,{style:'currency',currency:this.currency,minimumFractionDigits:0,maximumFractionDigits:2}).format(v); }
        catch{ return `${this.currency} ${v.toFixed(2)}`; } }
    round1(x){ const n=Number(x); return Number.isFinite(n) ? Math.round(n*10)/10 : 0; }
    nights(ci, co) {
        if (!ci || !co) return 0;
        const A = /^\d{4}-\d{2}-\d{2}$/.test(ci) ? new Date(ci + 'T00:00:00Z') : new Date(ci);
        const B = /^\d{4}-\d{2}-\d{2}$/.test(co) ? new Date(co + 'T00:00:00Z') : new Date(co);
        if (isNaN(A) || isNaN(B) || B <= A) return 0;
        const ms = Date.UTC(B.getUTCFullYear(), B.getUTCMonth(), B.getUTCDate()) -
            Date.UTC(A.getUTCFullYear(), A.getUTCMonth(), A.getUTCDate());
        return Math.floor(ms / 86400000);
    }

    fmtDateLocal(iso, locale = CURRENT_LOCALE) {
        if (!iso) return '';
        const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso));
        if (!m) return iso;

        const [, y, mo, d] = m;
        const dt = new Date(Date.UTC(+y, +mo - 1, +d));

        const now = new Date();
        const sameYear = dt.getUTCFullYear() === now.getUTCFullYear();

        const safeLocale = String(locale || '').trim().replace(/_/g, '-');

        const opts = { weekday: 'short', day: 'numeric', month: 'long', timeZone: 'UTC' };
        if (!sameYear) opts.year = 'numeric';

        try {
            return new Intl.DateTimeFormat(safeLocale, opts).format(dt);
        } catch {
            const mon = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            return `${['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][dt.getUTCDay()]} ${+d} ${mon[dt.getUTCMonth()]}` + (sameYear ? '' : ` ${dt.getUTCFullYear()}`);
        }
    }

    fmtDateTime(iso) {
        return this.fmtDateLocal(iso, CURRENT_LOCALE);
    }

    arrDateToIso(v) {
        if (!v) return '';
        if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) return v;

        if (Array.isArray(v) && v.length >= 3) {
            const [y, m, d] = v;
            const pad = (x) => String(x).padStart(2, '0');
            return `${y}-${pad(m)}-${pad(d)}`;
        }

        const m = typeof v === 'string' && v.match(/Date\((\d+)\)/);
        const d = m ? new Date(Number(m[1])) : new Date(v);
        return isNaN(d) ? '' : d.toISOString().slice(0, 10);
    }

    pickStay(payload){
        const list = payload?.roomStays?.content || [];
        if (!list.length) return null;

        const prio = { CHECKED_IN: 3, CONFIRMED: 2, CHECKED_OUT: 1 };
        const toTs = (arr)=> {
            if (!Array.isArray(arr) || arr.length<3) return 0;
            const [y,m,d] = arr;
            return Date.parse(`${y}-${String(m).padStart(2,'0')}-${String(d).padStart(2,'0')}T00:00:00Z`) || 0;
        };

        // відсортуємо за пріоритетом і найсвіжішою startDate
        const sorted = [...list].sort((a,b)=>{
            const pa = prio[a.roomStayStatus] || 0;
            const pb = prio[b.roomStayStatus] || 0;
            if (pa !== pb) return pb - pa;
            return (toTs(b.startDate) - toTs(a.startDate));
        });

        // якщо перший CANCELLED (рідко), знайдемо перший не-CANCELLED
        const found = sorted.find(s => s.roomStayStatus !== 'CANCELLED') || sorted[0];
        return found || null;
    }

    getStayDates(data) {
        const b = data?.booking || {};
        const ch = data?.chosenStay || {};
        // формуємо YYYY-MM-DD (приймається як plain текст у листі)
        const arrToIso = (v) => this.arrDateToIso(v);

        const df = b.dateFrom || arrToIso(ch.startDate) || '';
        const dt = b.dateTo   || arrToIso(ch.endDate)   || '';
        return { dateFrom: df, dateTo: dt };
    }

    getGuests(data) {
        const b = data?.booking || {};
        const ch = data?.chosenStay || {};
        return Number(b.adults ?? b.guests ?? ch.numberOfAdults) || '';
    }

    getUnitTitle(data) {
        const a = data?.apartment || data?.unit || {};
        return a.title || a.unitTypeName || a.unitName || '';
    }

    // ---- helpers for long-stay months & labels ----
    monthUnitsByBoundary(ciIso, coIso) {
        // скільки повних «календарних» місячних одиниць між датами, як у лонг-логіці
        const addMonthsClamp = (d, m) => {
            const y = d.getUTCFullYear();
            const mo = d.getUTCMonth();
            const dd = d.getUTCDate();
            const tMo = mo + m;
            const ty = y + Math.floor(tMo / 12);
            const tm = ((tMo % 12) + 12) % 12;
            const last = new Date(Date.UTC(ty, tm + 1, 0)).getUTCDate();
            const td = Math.min(dd, last);
            return new Date(Date.UTC(ty, tm, td));
        };
        if (!ciIso || !coIso) return 0;
        const ci = new Date(ciIso + 'T00:00:00Z');
        const co = new Date(coIso + 'T00:00:00Z');
        if (!(ci instanceof Date) || !(co instanceof Date) || isNaN(ci) || isNaN(co) || co <= ci) return 0;
        let m = 1;
        while (co > addMonthsClamp(ci, m)) m++;
        return m;
    }

    humanStayLenLabel(ciIso, coIso) {
        const n = this.nights(ciIso, coIso);
        if (!n) return '';

        const months = Math.floor(n / 30);
        const days = n % 30;
        const mPart = months ? `${months} ${months > 1 ? t('months', 'months') : t('month', 'month')}` : '';
        const dPart = days ? `${days} ${days > 1 ? t('days', 'days') : t('day', 'day')}` : '';
        return [mPart, dPart].filter(Boolean).join(', ');
    }

    pickMonthlyRate(apartment, booking, ciIso, coIso) {
        // 1) якщо в apartment.pricing є MONTHLY — беремо його
        const list = Array.isArray(apartment?.pricing) ? apartment.pricing : (apartment?.pricing ? [apartment.pricing] : []);
        const monthly = list.find(r => String(r.rateType || '').toUpperCase() === 'MONTHLY' && Number(r.amount) > 0);
        if (monthly) return Number(monthly.amount);

        // 2) fallback: з bookingNet / кількість «місячних одиниць»
        const months = this.monthUnitsByBoundary(ciIso, coIso);
        const net = Number(booking?.bookingNet || 0);
        if (months > 0 && net > 0) return net / months;

        return 0;
    }


    /* ------------ data ------------ */
    fetchBooking(){
        const ajaxUrl=(window.BL_AJAX && BL_AJAX.url) || '/wp-admin/admin-ajax.php';
        const nonce  =(window.BL_AJAX && BL_AJAX.nonce) || '';

        console.log('CONF code:', this.code, 'ref:', this.ref);

        return $.ajax({
            url: ajaxUrl, method:'POST', dataType:'json',
            data: { action:'bl_get_booking_details', _ajax_nonce:nonce, bookingReference: this.code, ref: this.ref }
        }).then(res=>{
            if(!res?.success) return Promise.reject(new Error(res?.data?.message||'Failed to load booking'));
            return res.data||{};
        });
    }


    /* ------------ render blocks ------------ */

    renderPriceBreakdownBlock(payload){
        const a  = payload?.apartment || {};
        const bk = payload?.booking || {};
        const stay = payload?.chosenStay || this.pickStay(payload) || {};

        const ciIso = this.arrDateToIso(stay.startDate) || (bk.dateFrom || '').slice(0,10);
        const coIso = this.arrDateToIso(stay.endDate)   || (bk.dateTo   || '').slice(0,10);

        const months = this.monthUnitsByBoundary(ciIso, coIso);
        const monthlyRent = this.pickMonthlyRate(a, bk, ciIso, coIso);
        const extrasTotal = Number(bk.bookingExtrasNet || 0) + Number(bk.bookingExtrasVat || 0);
        const vatTotal    = Number(bk.bookingVat || 0);

        const extrasPerMonth = months ? (extrasTotal / months) : 0;
        const vatPerMonth    = months ? (vatTotal    / months) : 0;
        const totalPerMonth = monthlyRent + extrasTotal + vatPerMonth;
        const ajax = window.BL_AJAX || {};
        const longTermRentalIncludes = ajax.long_term_rental_includes ?
            `<div class="bg-white border border-gray-200 rounded-lg p-4 mt-4">
                <div class="text-sm text-basel-gray">${ajax.long_term_rental_includes}</div>
            </div>`:'';

        const extrasSection = extrasPerMonth > 0 ? `
            <div class="flex justify-between">
              <span class="text-sm text-gray-600 font-medium">${t('extra_services', 'Extra services')}:</span>
              <span class="font-medium">${this.money(extrasTotal)}</span>
            </div>
        ` : '';

        const vatRow = vatPerMonth > 0 ? `
            <div class="flex justify-between">
              <span class="text-sm text-gray-600 font-medium">${t('vat', 'VAT')}:</span>
              <span class="font-medium">${this.money(vatPerMonth)}</span>
            </div>
        ` : '';

        const html = `
      <div class="rounded-lg bg-card text-card-foreground shadow-lg border border-gray-200">
        <div class="flex flex-col space-y-1.5 p-6">
          <h3 class="tracking-tight text-lg font-semibold text-basel-gray">${t('monthly_cost_breakdown', 'Monthly Cost Breakdown')}</h3>
        </div>
        <div class="p-6 pt-0 space-y-4">
          <div class="space-y-3">
            <div class="flex justify-between">
              <span class="text-basel-gray">${t('monthly_rent', 'Monthly rent')}</span>
              <span class="font-medium">${this.money(monthlyRent)}</span>
            </div>

            ${extrasSection}
            ${vatRow}

            <div class="border-t border-gray-200 pt-3">
              <div class="flex justify-between font-bold text-lg">
                <span class="text-basel-gray">${t('total_per_month', 'Total per month')}</span>
                <span>${this.money(totalPerMonth)}</span>
              </div>
            </div>
          </div>
          ${longTermRentalIncludes}
        </div>
      </div>`;
        this.$priceHost.html(html);
    }

    renderBookingDetailsBlock(payload) {
        // ---- source data
        const a = payload?.apartment || {};
        const stay = payload?.chosenStay || this.pickStay(payload) || {};
        const bk = payload?.booking || {};

        // apartment bits
        const title = a.title || a.unitName || 'Apartment';
        const city = a.city || '';
        const area = a.areaName || '';
        const address    = a.addressLine1 || '';
        const loc     = [address, area, city].filter(Boolean).join(', ');
        const bedsNum = Number(a?.specifications?.numberOfBedrooms ?? a?.specifications?.bedRoomCount ?? 0);
        const bedLbl  = bedsNum === 0 ? 'Studio' : (bedsNum ? `${bedsNum} bed${bedsNum>1?'s':''}` : '');
        const guests  = Number(a?.specifications?.maxOccupancy || 0);
        const guestsLbl = guests ? `Up to ${guests} guest${guests>1?'s':''}` : '';

        // image
        const img = (a?.mainImage?.url || (Array.isArray(a?.images) && a.images[0]) || '/placeholder.svg')
            .toString().replace(/^\/\//,'https://');

        // dates / length
        const ciIso = this.arrDateToIso(stay.startDate) || (bk.dateFrom || '').slice(0,10);
        const coIso = this.arrDateToIso(stay.endDate)   || (bk.dateTo   || '').slice(0,10);
        const lenHuman = this.humanStayLenLabel(ciIso, coIso);
        const ciLabel = this.fmtDateTime(ciIso);
        const coLabel = this.fmtDateTime(coIso);

        // ---- HTML (same structure, just injected values)
        const html = `
      <div class="rounded-lg bg-card text-card-foreground shadow-sm border border-gray-200">
        <div class="flex flex-col space-y-1.5 p-6">
          <h3 class="tracking-tight text-xl font-semibold text-basel-gray">${t('requested_accommodation', 'Requested Accommodation')}</h3>
        </div>
        <div class="p-6 pt-0 space-y-4">
          <div class="flex gap-4 p-4 border border-gray-200 rounded-lg">
            <img src="${this.esc(img)}"
                 alt="${this.esc(title)}"
                 class="w-24 h-24 object-cover rounded-lg flex-shrink-0">
            <div class="flex-1">
              <h3 class="font-semibold text-basel-gray mb-2">${this.esc(title)}</h3>
              <div class="flex items-center text-sm text-gray-600 mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                     viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="lucide lucide-map-pin w-4 h-4 mr-1">
                  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                ${this.esc(loc || '—')}
              </div>
              <div class="flex items-center space-x-4 text-sm text-gray-600">
                <div class="flex items-center space-x-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                       viewBox="0 0 24 24" fill="none" stroke="currentColor"
                       stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                       class="lucide lucide-bed w-4 h-4">
                    <path d="M2 4v16"></path>
                    <path d="M2 8h18a2 2 0 0 1 2 2v10"></path>
                    <path d="M2 17h20"></path>
                    <path d="M6 8v9"></path>
                  </svg>
                  <span>${this.esc(bedLbl || '—')}</span>
                </div>
                <div class="flex items-center space-x-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                       viewBox="0 0 24 24" fill="none" stroke="currentColor"
                       stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                       class="lucide lucide-users w-4 h-4">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                  <span>${this.esc(guestsLbl || '—')}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="flex items-center gap-3 p-4 bg-gray-50 rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                 viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                 stroke-linecap="round" stroke-linejoin="round"
                 class="lucide lucide-calendar w-5 h-5 text-basel-gray">
              <path d="M8 2v4"></path>
              <path d="M16 2v4"></path>
              <rect width="18" height="18" x="3" y="4" rx="2"></rect>
              <path d="M3 10h18"></path>
            </svg>
            <div>
              <div class="font-medium text-basel-gray">${t('length_of_stay', 'Length of Stay')}</div>
              <div class="text-sm text-gray-600">
                ${this.esc(ciLabel)} - ${this.esc(coLabel)}${lenHuman ? ` (${this.esc(lenHuman)})` : ''}
              </div>
            </div>
          </div>
        </div>
      </div>`;
        this.$bdHost.html(html);
    }

    renderBookingDate(data) {
        const $targets = $('[data-role="booking-date"]');
        if (!$targets.length) return;

        const ref = String(data?.booking?.bookingReference || '');
        const m = ref.match(/^(\d{4})(\d{2})(\d{2})/); // YYYYMMDD...
        if (!m) { $targets.text(''); return; }

        const year  = Number(m[1]);
        const month = Number(m[2]) - 1; // 0-based
        const day   = Number(m[3]);

        const dt = new Date(Date.UTC(year, month, day));
        if (isNaN(dt)) { $targets.text(''); return; }

        // Month name in English (як і було)
        const monthName = new Intl.DateTimeFormat('en-US', { month: 'long', timeZone: 'UTC' }).format(dt);

        const ordinal = (n) => {
            const v = n % 100;
            if (v >= 11 && v <= 13) return `${n}th`;
            switch (n % 10) {
                case 1: return `${n}st`;
                case 2: return `${n}nd`;
                case 3: return `${n}rd`;
                default: return `${n}th`;
            }
        };

        const label = `${monthName} ${ordinal(day)} ${year}`;
        $targets.text(label);
    }

    async boot(){
        if (!this.code || !this.ref) { this.showError('Required parameter is missing.'); return; }
        this.showLoader();
        try{
            const data  = await this.fetchBooking();      // { booking, roomStays:{content:[]}, apartment, chosenStay? }

            this.renderBookingDetailsBlock(data);
            this.renderPriceBreakdownBlock(data);

            this.renderBookingDate(data);

            this.showContent();
        }catch(e){
            this.showError(e?.message||'Failed to load booking.');
        }
    }
}

$(document).ready(()=> new ConfirmationLongApi());
